import isChromatic from 'chromatic/isChromatic';
import cn from 'classnames';
import styles from './Input.module.css';

type Props = React.ComponentPropsWithRef<'input'> & {
  className?: string;
  hasError?: boolean;
  enablePWManagers?: boolean;
};

export const Input = ({ hasError, className, enablePWManagers, ...htmlProps }: Props) => {
  const classes = cn('border-focusable', styles.Input, className, {
    'has-error': hasError,
    [styles.Input___hiddenCursor]: isChromatic(),
  });

  return (
    <input
      className={classes}
      aria-invalid={hasError}
      // https://www.stefanjudis.com/snippets/turn-off-password-managers/
      data-lpignore={enablePWManagers ? undefined : 'true'}
      data-form-type={enablePWManagers ? undefined : 'other'}
      data-bwignore={!enablePWManagers}
      data-1p-ignore={!enablePWManagers}
      {...htmlProps}
    />
  );
};
